/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Správce fyzických datových úložišť pro standardní webové technologie.
 * @implements {DriveManager}
 */
class WebDriveManager {
  /** @inheritdoc */
  getAllUnits() {
    // Web neumožňuje zjistit informace o úložných jednotkách.
    return Promise.resolve([]);
  }

  /** @inheritdoc */
  getInfo() {
    return new Promise((resolve) =>
      resolve(this.getAllUnits().then((driveUnitArray) => ({ driveUnitArray })))
    );
  }
}

export default WebDriveManager;
